import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http'
import { Constant } from '../../../environments/constants';
import { Utils } from '../../../utils/utils';
import { RefDataService } from '../context/ref-data.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import * as fromModel from '../../services/models/';


@Injectable({
  providedIn: 'root'
})
export class ReferenceService {

  constructor(private http: HttpClient,
              private refDataService:RefDataService,
              private appMonitoringService: AppMonitoringService) { }

  getStatesRefrenceData() {
    return this.http.get('./assets/reference/states.json');        
  }

  getEmploymentTypesRefrenceData() {
    return this.http.get('./assets/reference/employment-types.json');        
  }

  getResultRefrenceData() {
    return this.http.get('./assets/reference/results.json');        
  }

  getPlanningUIRefrenceData() {
    this.http.get('./assets/reference/planning-ref-data.json').subscribe(refData=>{
      this.refDataService.dispatchAction(fromModel.REF_DATA_ACTION.PLANNINGUI, "ReferenceService-getPlanningUIRefrenceData", refData);
    }, err=>{
      this.refDataService.dispatchAction(fromModel.REF_DATA_ACTION.PLANNINGUI,"ReferenceService-getPlanningUIRefrenceData", {Error: fromModel.ERRORCODE.LOCALAPIERROR, ErrorDetails: JSON.stringify(err)});
      console.log("Error getting Planning UI Refrence Data" + JSON.stringify(err));      
      this.appMonitoringService.traceMsg("Error getting Planning UI Refrence Data ", JSON.stringify(err) , 'Error');
    });
  }

  getSettingsRefrenceData() {
    return this.http.get('./assets/reference/settings.json');        
  }

  getDefaultExpenseReferenceDataAPI(state: string){
    if(state){
      state = state.toUpperCase();
    }
    return this.http.get(encodeURI(Constant.uri.defaultExpenseRefapi+'?state='+ state), Utils.getHttpOptions());    
  }
  
  getDefaultExpenseReferenceData(state: string){
    this.getDefaultExpenseReferenceDataAPI(state).subscribe(refData=>{
      this.refDataService.dispatchAction(fromModel.REF_DATA_ACTION.STATEEXP, "ReferenceService-getDefaultExpenseReferenceData", refData);
    }, err=>{
      this.refDataService.dispatchAction(fromModel.REF_DATA_ACTION.STATEEXP,"ReferenceService-getDefaultExpenseReferenceData", {Error: fromModel.ERRORCODE.APIERROR, ErrorDetails: JSON.stringify(err)});
      console.log("Error getting DefaultExpenseReference Data for State: " + state +"; " + JSON.stringify(err));      
      this.appMonitoringService.traceMsg("Error getting DefaultExpenseReference Data for State: " + state, JSON.stringify(err) , 'Error');
    });
  }  

  getKeyValueReferenceDataAPI(){
    return this.http.get(Constant.uri.keyValueRefapi, Utils.getHttpOptions());    
  }

  getKeyValueReferenceData(){
    this.getKeyValueReferenceDataAPI().subscribe(refData=>{
      this.refDataService.dispatchAction(fromModel.REF_DATA_ACTION.KEYVALUE, "ReferenceService-getKeyValueReferenceData", refData);
    }, err=>{
      this.refDataService.dispatchAction(fromModel.REF_DATA_ACTION.KEYVALUE,"ReferenceService-getKeyValueReferenceData", {Error: fromModel.ERRORCODE.APIERROR, ErrorDetails: JSON.stringify(err)});
      console.log("Error getting KeyValueReference Data " + JSON.stringify(err));      
      this.appMonitoringService.traceMsg("Error getting KeyValueReference Data ", JSON.stringify(err) , 'Error');
    });
  }

  getLifeExpectancyReferenceDataAPI(){
    return this.http.get(Constant.uri.lifeExpectancyRefapi, Utils.getHttpOptions());    
  }

  getLifeExpectancyReferenceData(){
    this.getLifeExpectancyReferenceDataAPI().subscribe(refData=>{
      this.refDataService.dispatchAction(fromModel.REF_DATA_ACTION.LIFEEXPECTANCY, "ReferenceService-getLifeExpectancyReferenceData", refData);
    }, err=>{
      this.refDataService.dispatchAction(fromModel.REF_DATA_ACTION.LIFEEXPECTANCY,"ReferenceService-getLifeExpectancyReferenceData", {Error: fromModel.ERRORCODE.APIERROR, ErrorDetails: JSON.stringify(err)});
      console.log("Error getting LifeExpectancy Data " + JSON.stringify(err));      
      this.appMonitoringService.traceMsg("Error getting LifeExpectancy Data ", JSON.stringify(err) , 'Error');
    });
  }

  getAccountReferenceData(){
    this.http.get(Constant.uri.accountRefapi, Utils.getHttpOptions()).subscribe(refData=>{
      this.refDataService.dispatchAction(fromModel.REF_DATA_ACTION.ACCTYPE, "ReferenceService-getAccountReferenceData", refData);
    }, err=>{
      this.refDataService.dispatchAction(fromModel.REF_DATA_ACTION.ACCTYPE,"ReferenceService-getAccountReferenceData", {Error: fromModel.ERRORCODE.APIERROR, ErrorDetails: JSON.stringify(err)});
      console.log("Error getting Account Type Ref Data " + JSON.stringify(err));      
      this.appMonitoringService.traceMsg("Error getting Account Type Ref Data ", JSON.stringify(err) , 'Error');
    });
  }
}
